<af-main-container
    [title]="(documentId ? 'i18n_lib_breadcrumb#OrganizationDocumentEdit' : 'i18n_lib_breadcrumb#OrganizationDocumentCreate') | translate"
    [spinnerIds]="['initial']"
    [tabPathToTab]="tabPathToTab"
    [filterNavigationPath]="Path.DOCUMENTS"
    [breadcrumbCustomizer]="breadcrumbCustomizer"
    [queryParamsHandling]="'merge'">
    @if (isLoaded) {
        <div fxLayout="column" class="w-100 radius-16 bc-mono-white p-24 mt-24">
            <form [formGroup]="form"
                  (submit)="submit()"
                  fxLayout="column"
                  fxLayoutAlign="start start">
                <af-files class="w-100"
                          [form]="form"
                          [bucket]="BucketName.ORGANIZATION_FILES"
                          [filterDictionaryBy]="organizationScope"
                          [excludeFromDictionary]="[]"
                          [attachments]="attachments"
                          [hasAddButton]="!documentId"
                          [multiple]="!documentId"
                          [mimeTypes]="ORGANIZATION_MIME_TYPES"
                          [required]="true"
                          label="i18n_af_labelAdditionalDocuments"
                          hintTranslationKey="i18n_af_hintOrganizationDocument"/>

                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-24">
                    <ui-kit-button spinnerId="submit"
                                   [disabled]="form.invalid"
                                   [label]="'i18n_af_buttonSave' | translate"/>
                    <ui-kit-button color="accent"
                                   buttonType="button"
                                   type="text"
                                   [label]="'i18n_af_buttonCancel' | translate"
                                   (clickListener)="navigateBack()"/>
                </div>
            </form>
        </div>
    }
</af-main-container>
